import React from 'react'
import Navbar from './containers/Navbar'

const Topbar = () => {
  return (
    <div>
      <Navbar />
    </div>
  )
}

export default Topbar
